module.exports = __webpack_public_path__ + "static/media/photo43.e349cf46.jpg";